"use client";

import { GlobalContext } from "@/contexts/SiteDataContext";
import { windowIsExist } from "@/utils/browser";
import scriptConfigurations from "./config";
import Script from "next/script";
import { useContext, useEffect } from "react";
import "./styles.scss";

const ChatWidget = () => {
  const { siteData } = useContext(GlobalContext).context;
  const isPaymentPage = windowIsExist ? window.location.pathname.startsWith("/payment") : false;
  const chatActive = siteData.hasChat && siteData.chatActive;
  const showChatWidget = chatActive && !isPaymentPage;
  const chatWidgetId = siteData.metadata && siteData.metadata.chatWidgetId;
  const theme = siteData.theme || "classic";

  useEffect(() => {
    if (windowIsExist && showChatWidget) {
      // add script pre chat and customer url
      const scriptPreChatSDK = document.createElement("script");
      scriptPreChatSDK.src = "https://snippets.freshchat.com/js/fc-pre-chat-form-v2.min.js";
      document.body.insertAdjacentElement("beforeend", scriptPreChatSDK);

      const currentUrl = window.location.href;
      const scriptConfig = document.createElement("script");
      scriptConfig.innerHTML = scriptConfigurations(currentUrl, theme);
      document.body.insertAdjacentElement("beforeend", scriptConfig);
    }
  }, [showChatWidget, chatWidgetId, theme]);

  return showChatWidget ? (
    <Script
      id="script-chat-widget"
      src="//eu.fw-cdn.com/11260794/416863.js"
      strategy="lazyOnload"
      data-chat="true"
      data-widget-id={chatWidgetId}></Script>
  ) : null;
};

export default ChatWidget;
